<div style="height: 100%">
    <app-ng-table [columns]="columns" [data]="tableData" scrollable="true" scrollHeight="60vh"
        allowFilters (sortFunction)="handleSort($event)" [reorderableColumns]="reorderableColumns"/>
</div>